<template>
  <v-container>
    <div style="background-color: #ffffff" id="pdfContent" class="p-3">
      <b-row class="dashed-border pb-3">
        <b-col md="1" class="info-box d-flex align-items-center">
          <b-button
            size="sm"
            @click="backButton"
            class="mr-2 my-0 main-navigation-button"
            variant="light"
          >
            <i class="fa fa-arrow-left" aria-hidden="false"></i>
          </b-button>
        </b-col>
        <b-col class="box-border info-box d-flex align-items-center">
          <h5 class="order-info">TAX INVOICE</h5>
        </b-col>
        <b-col class="box-border info-box">
          <p class="order-info">
            Order Id: {{ invoiceData ? invoiceData.orderId : "" }}
          </p>
          <p class="order-info">Order Date: {{ createdDate }}</p>
        </b-col>
        <b-col class="info-box">
          <p class="order-info">Payment Mode: COD</p>
        </b-col>
      </b-row>
      <b-row class="dashed-border">
        <b-col md="12">
          <div class="d-flex flex-column align-items-center mt-3 seller-box">
            <b-img
              :src="
                objData.provider &&
                objData.provider.organization &&
                objData.provider.organization.logo
                  ? objData.provider.organization.logo.url
                  : ''
              "
              width="60"
              height="60"
              alt=""
            />
            <h5 class="order-info mb-2">
              {{
                objData.provider && objData.provider.organization
                  ? objData.provider.organization.name
                  : ""
              }}
            </h5>
            <p class="order-info">
              {{
                objData.provider &&
                objData.provider.office &&
                objData.provider.office.address
                  ? objData.provider.office.address.city
                  : ""
              }}
            </p>
            <p class="order-info">
              {{
                objData.provider &&
                objData.provider.office &&
                objData.provider.office.address
                  ? objData.provider.office.address.state
                  : ""
              }}
              -
              {{
                objData.provider.office && objData.provider.office.address
                  ? objData.provider.office.address.zip
                  : ""
              }}
            </p>
            <p class="order-info mb-3">
              Phone:
              {{
                objData.provider &&
                objData.provider.authentication &&
                objData.provider.authentication.phone
              }}
            </p>
          </div></b-col
        >
      </b-row>
      <b-row class="dashed-border">
        <b-col md="3"> <h6 class="order-info">Item</h6></b-col>
        <b-col md="1"> <h6 class="order-info"style="text-align: center;">Qty</h6> </b-col>
        <b-col md="2"> <h6 class="order-info ml-4"style="text-align: center;">MRP</h6> </b-col>
        <b-col md="2"> <h6 class="order-info"style="text-align: center;">Base Price</h6> </b-col>
        <b-col md="2"> <h6 class="order-info"style="text-align: center;">Tax</h6> </b-col>
        <b-col md="2"> <h6 class="order-info"style="text-align: center;">Amount(₹)</h6> </b-col>
      </b-row>
      <b-row class="dashed-border">
        <div
          class="d-flex w-100 showOrder"
          v-for="item in invoiceData.ItemsByProvider"
          :key="item._id"
        >
          <b-col md="3">
            <p class="order-info">{{ item.name }}</p></b-col
          >
          <b-col md="1">
            <p class="order-info"
            style="text-align: center;"
            >{{ item.qty }}</p>
          </b-col>
          <b-col md="2">
            <p class="order-info ml-4" style="text-align: center;" >{{ item.unitPrice }}</p>
          </b-col>
          <b-col md="2">
            <p class="order-info" style="text-align: center;" >{{ item.price }}</p>
          </b-col>
          <b-col md="2">
            <p class="order-info" style="text-align: center;" >{{ item.totalTaxes }}</p>
          </b-col>
          <b-col md="2">
            <p class="order-info"style="text-align: center;">{{ item.finalPrice }}</p>
          </b-col>
        </div>
      </b-row>
      <b-row class="dashed-border">
        <b-col md="3"> <h6 class="order-info">Total</h6></b-col>
        <b-col md="5">
          <h6 class="order-info"style="left: 5%; position: relative;">
            {{ Object.keys(invoiceData && invoiceData.ItemsByProvider).length }}
          </h6>
        </b-col>
        <b-col md="1">
          <h6 class="order-info"style="left: 85%; position: relative;">{{ totalTaxAmount.toFixed(2) }}</h6>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="2">
          <h6 class="order-info pr-2"style="left: 37%; position: relative;">{{ totalAmount }}</h6>
        </b-col>
      </b-row>
      <!-- <b-row class="dashed-border d-flex justify-content-end">
          <b-col md="1"> <p>CGST</p> </b-col>
          <b-col md="3">
            <p class="text-right pr-2">15</p>
          </b-col>
        </b-row> -->
      <b-row>
        <b-col md="12"
          ><div
            class="d-flex flex-column align-items-center mt-4 dashed-border"
          >
            <!-- <p>You have saved Rs.200+ on this order + eligible Cash Back</p> -->
            <p class="order-info">Thank You for shoping with us</p>
            <p class="order-info">Vist us again</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col md="12" class="mt-2">
        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary"
            @click="downloadInvoicePdf"
          >
            <span class="download-invoice pr-3 pl-3">Download Invoice</span>
          </button>
        </div>
      </b-col>
    </b-row>
  </v-container>
</template>

<script>
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      objData: (state) => state.order.orderDetailsData,
      invoiceData: (state) => state.order.invoiceDetails,
      orderList: (state) => state.order.listOrderAllUsers,
      sellerInfo: (state) => state.partner.partnerDetailsById,
    }),
    createdDate() {
      return moment(this.objData.createdAt).format("DD-MM-YYYY, hh:mm A");
    },
    // async orderInfo() {
    //   let orderObject = this.orderList.find(
    //     (obj) => obj._id === this.$route.params.orderId
    //   );
    //   await this.$store.dispatch(
    //     "partner/fetchPartnerDetailsById",
    //     orderObject.provider
    //   );
    //   return orderObject;
    // },
    // sellerPhone() {
    //   const number = this.sellerInfo?.office?.phone?.map((each) => each.number);
    //   return number[0];
    // },
    totalTaxAmount() {
      let taxes =
        this.invoiceData &&
        this.invoiceData.ItemsByProvider.map((each) => each.totalTaxes);
      let tax = 0;
      for (let i = 0; i < taxes.length; i++) {
        tax = tax + taxes[i];
      }
      return tax;
    },
    totalAmount() {
      let totalBill = this.invoiceData.ItemsByProvider.map(
        (each) => each.finalPrice
      );
      let total = 0;
      for (let i = 0; i < totalBill.length; i++) {
        total = total + totalBill[i];
      }
      return total;
    },
  },
  methods: {
    backButton() {
      this.$router.push({
        name: "manage-order-details",
        params: { orderId: this.$route.params.orderId },
      });
    },
    downloadInvoicePdf() {
      const pdfDoc = document.querySelector("#pdfContent");
      html2canvas(pdfDoc, {
        allowTaint: true,
        useCORS: true,
        scale: 1,
        width: 1165,
        height: 900,
      }).then((canvas) => {
        var imgData = canvas.toDataURL("image/png");
        var doc = new jsPDF("p");
        doc.addImage(imgData, "PNG", 10, 10, 190, 190);
        doc.save("invoice.pdf");
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("order/fetchInvoiceData", this.$route.params.id);
    await this.$store.dispatch(
      "order/getOrderDetails",
      this.$route.params.orderId
    );
  },
};
</script>

<style scoped>
.dashed-border {
  border-bottom: 2px dashed #e3e3e3;
}
.box-border {
  border-right: 2px dashed #e3e3e3;
}
.info-box p,
h5 {
  margin-bottom: 0px;
}
.seller-box p {
  margin-bottom: 0.3rem;
}
.order-info {
  color: black;
  font-size: 16px;
}
.download-invoice {
  color: white;
  font-size: 16px;
}
.showOrder p {
  margin: 10px 0;
}
</style>
